import React, { useState, useEffect } from "react";
import { useTheme } from '@repo/shared';
import { useParams, useHistory } from "react-router-dom";
import DatePicker from "react-multi-date-picker"
import DatePanel from "react-multi-date-picker/plugins/date_panel"

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'

import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

import "react-datepicker/dist/react-datepicker.css";
import {  Container, Card, Spinner } from "react-bootstrap";
import LoadingSpinner from '../common/LoadingSpinner';
import StudentDataService from "../../services/student/StudentService";
import EventDataService from "../../services/event/EventService";

const Event = props => {
  const { id } = useParams();
  const history = useHistory();
  const initialEventState = EventDataService.initialiseNewEvent();
  const [currentEvent, setCurrentEvent] = useState(initialEventState);
  const [message, setMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [updateMode, setUpdateMode] = useState(false);
  const [saving, setSaving] = useState(false);
  const [studentsForEvent, setStudentsForEvent] = useState([]);
  const [allStudents, setAllStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const { appTheme } = useTheme();
  const getEvent = id => {
    EventDataService.get(id)
      .then(response => {
        console.log('got this event', response);
        //convert the dates from strings to Date
        response.dates = response.dates.map(d => new Date(Date.parse(d)));

        setCurrentEvent({...response});
        setLoading(false);
      })
      .catch(e => {
        console.log(e);
      });
  };
  
  const addStudentToEvent = student => {
    studentsForEvent.unshift(student);
    setStudentsForEvent([...studentsForEvent]);
  }

  const removeStudentFromEvent = student => {
    const sfc = studentsForEvent.filter(s => s.id !== student.id)
    setStudentsForEvent([...sfc]);
  }

  const getAllStudents = () => {
    setErrorMessage('');
    StudentDataService.getAll()
      .then(response => {
        //Filter out students who are already assigned to an event other than this one for this year and semester
        const studentsWithoutEvent = response.filter(s => {
          const existingEvent = s.events?.find(e => {
            return e.eventId !== id && e.active;
          })
          return !existingEvent;
        })
        setAllStudents(studentsWithoutEvent);
      })
      .catch(e => {
        console.log(e);
      });
  };

  useEffect(() => {
    document.title = `${appTheme?.appName} - Event`
    const bg = async () => {
      getAllStudents();
    }
    bg();
      
  }, []);


  useEffect(() => {
    if (id) {
      getEvent(id);
      setUpdateMode(true);
      StudentDataService.getAllForEvent(id)
        .then((response) => {
          setStudentsForEvent(response);
          console.log('Students for event', JSON.stringify(response, null, 2));
        })
        .catch((e) => {
          console.log(e);
        });
    } else {
      setLoading(false);
    }
  }, [id]);

  const handleInputChange = event => {
    const { name, value } = event.target;
    setCurrentEvent({ ...currentEvent, [name]: value });
  };

  const handleDatesSubmit = dates => {
    console.log(dates);
    const newDates = dates.map(d => {
      d['hour'] = 4;
      const newDate = new Date(d)
      return newDate;
    });
    setCurrentEvent({ ...currentEvent, dates: newDates });
    console.log('new dates', newDates);
  }

  const gotoStudentPage = forStudent => {
      console.log('Opening student page for student: ', forStudent);
      history.push("../student/" + forStudent.id);
  };

  const validate = () => {
    const errorFields = [];

    if (currentEvent.time) {
      const regex = new RegExp('^([01][0-9]|2[0-3]):?([0-5][0-9])$');

      if (!regex.test(currentEvent.time)) {
        setErrorMessage(`Please specify time in HH:MM format`);
        return false;
      }
    }

    if (!currentEvent.title) {
      errorFields.push('Title');
    }

    if (!currentEvent.dates || !currentEvent.dates.length) {
      errorFields.push('Event Dates');
    } 

    if (errorFields.length) {
      setErrorMessage(`These fields may not be blank: ${errorFields.join(',')}`);
      return false;
    } else {
      setErrorMessage(null);
      return true;
    }
  };

  const addEvent = (e) => {
    e.preventDefault();
    setSaving(true);
    if (validate()) {
      EventDataService.create(currentEvent, studentsForEvent)
        .then(response => {
          console.log(response);
          setMessage("The Event was saved successfully!");
          history.goBack();
        })
        .catch(e => {
          console.log(e);
          setSaving(false);
        });
      } else {
        setSaving(false);
      }
  };

  const updateEvent = (e) => {
    e.preventDefault();
    setSaving(true);
    if (validate()) {
      EventDataService.update(currentEvent.id, currentEvent, studentsForEvent)
        .then(response => {
          console.log(response);
          setMessage("The Event was updated successfully!");
          history.goBack();
        })
        .catch(e => {
          console.log(e);
          setSaving(false);
        });
      } else {
        setSaving(false);
      }
  };

  const deleteEvent = (e) => {
    e.preventDefault();
    confirmAlert({
      title: 'Delete Event',
      message: `Are you sure you want to delete event ${currentEvent.title ? currentEvent.title : ''}?`,
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            setSaving(true);
            EventDataService.remove(currentEvent.id)
              .then(response => {
                console.log(response);
                history.goBack();
              })
              .catch(e => {
                console.log(e);
                setSaving(false);
              });
          }
        },
        {
          label: 'No',
          onClick: () => {}
        },
      ]
    });
  };

  const DateInput = ({ openCalendar, stringDates, handleValueChange }) => {
    
    stringDates.sort();
    return (
      <div
        style={{
          width: "100%",
          minHeight: "64px",
          display: "block",
          cursor: "pointer"
        }}
        onClick={openCalendar}
      >
        { stringDates.length 
          ?
          <ol>
            {stringDates.map((d, index) => {
              return <li>{d}</li>;
            })}
          </ol>
          : <div style={{color: 'gray'}}>Press to select Dates</div>
          }
      </div>
    );
  };


  const truncate = (input, to) => input.length > to ? `${input.substring(0, to)}...` : input;

  const renderEnrolmentNotes = (student, position) => {
    if (!student.parentNotes) return null;

    //short notes
    if (student.parentNotes.length <= 15) {
      return (
        <tr className={position%2 ? 'studentitemOdd' : 'studentitemEven'} style={{minHeight: 16}} onClick={() => removeStudentFromEvent(student)}>
          <td colSpan={4}><span style={{fontSize: 10, fontStyle: 'italic'}}>{`(${student.parentNotes})`}</span></td>
        </tr>
      ) 
    }
    return (
      <tr className={position%2 ? 'studentitemOdd' : 'studentitemEven'} style={{minHeight: 16}} onClick={() => removeStudentFromEvent(student)}>
          <td colSpan={3}><span style={{fontSize: 10, fontStyle: 'italic'}}>{`(${truncate(student.parentNotes, 45)}) `}</span></td>
          <td onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            alert(student.parentNotes);
          }}>
          <FontAwesomeIcon style={{fontSize: 20, color: '#0d6efd'}} size={64} icon={faInfoCircle}/>
          </td>
        </tr>
    )
  }

  const renderBody = () => {
    console.log('rendering body for event', currentEvent);
    return (
      <>
      <form>
          <div className="d-flex justify-content-between align-items-flex-end gap-3">
            <div className="form-group flex-grow-1">
              <label htmlFor="title">Title</label>
              <input
                type="text"
                className="form-control"
                id="title"
                name="title"
                value={currentEvent.title}
                onChange={handleInputChange}
              />
            </div>
            <div className="form-check mb-3">
              <input
                className="form-check-input"
                type="checkbox"
                id="active"
                name="active"
                checked={currentEvent.active}
                onChange={(event) => {
                  const {checked} = event.target;
                  setCurrentEvent({ ...currentEvent, active: checked });
                }}
              />
              <label className="form-check-label" htmlFor="active">
                Active
              </label>
            </div>
            </div>
            <div className="form-group">
              <label htmlFor="notes">Notes</label>
                <textarea
                  style={{height: 100}}
                  type="text"
                  className="form-control"
                  id="notes"
                  name="notes"
                  value={currentEvent.notes || ''}
                  onChange={handleInputChange}
                />
            </div>
            <div className="form-group">
              <label htmlFor="dates">Dates</label>
              <div style={{display: 'flex'}}>
                <DatePicker
                    render={<DateInput />}
                    multiple
                    sort
                    containerStyle={{
                      width: "100%",
                      display: "block", 
                      border: "1px solid #ced4da",
                      borderRadius: ".25rem"
                    }}
                    onChange={handleDatesSubmit}
                    value={currentEvent.dates || []}
                    plugins={[
                    <DatePanel header={currentEvent.dates ? `${currentEvent.dates.length} Dates` : 'Dates'}/>
                    ]}
                  />
              </div>
            </div>
            <div className="d-flex justify-content-between">
              <div className="form-group col-5" >
                <label htmlFor="title">Location</label>
                <input
                  type="text"
                  className="form-control"
                  id="location"
                  name="location"
                  value={currentEvent.location}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-group col-5" >
                <label htmlFor="title">Age Range</label>
                <input
                  type="text"
                  className="form-control"
                  id="ages"
                  name="ages"
                  value={currentEvent.ages}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="title">Teacher</label>
              <input
                type="text"
                className="form-control"
                id="teacher"
                name="teacher"
                value={currentEvent.teacher}
                onChange={handleInputChange}
              />
            </div>
            <br></br>

            <div className="student-list-group">
              <span className="form-group student-list" style={{marginLeft: 2}}>
                <label htmlFor="description">All Students</label>
                {
                  allStudents.length
                  ? (
                    <table className="studentListTable">
                      <thead>
                        <td style={{width: '70%'}}>Name</td>
                        <td style={{width: '10%'}}>Age</td>
                        <td style={{width: '10%'}}>Year</td>
                        <td style={{width: '10%'}}></td>
                      </thead>
                      {
                        allStudents.map((ss,i) => {
                          return (
                            <tr className={i%2 ? 'studentitemOdd' : 'studentitemEven'} onClick={() => addStudentToEvent(ss)}>
                              <td style={{height: 32, width: '70%'}}>{ss.firstName} {ss.lastName}</td>
                              <td style={{width: '10%', textAlign: 'right'}}>{ss.age}</td>
                              <td style={{width: '10%', textAlign: 'right'}}>{ss.year}</td>
                              <td style={{width: '10%'}}></td>
                            </tr>
                          );
                        })
                      }
                    </table>
                    )
                  : <div>No Students Available</div>
                }
              </span>
              <span className="form-group student-list" style={{marginLeft: 2}}>
                <label htmlFor="description">Selected Students ({studentsForEvent.length})</label>
                {
                  studentsForEvent.length
                  ? (
                    <table className="studentListTable">
                      <thead>
                        <td style={{width: '70%'}}>Name</td>
                        <td style={{width: '10%'}}>Age</td>
                        <td style={{width: '10%'}}>Year</td>
                        <td style={{width: '10%'}}></td>
                      </thead>
                      {
                        studentsForEvent.map((s,i) => {
                          return ([
                            <tr className={i%2 ? 'studentitemOdd' : 'studentitemEven'} onClick={() => removeStudentFromEvent(s)}>
                              <td  style={{width: '70%', height: 32}}>{s.firstName} {s.lastName}</td>
                              <td style={{width: '10%', textAlign: 'right'}}>{s.age}</td>
                              <td style={{width: '10%', textAlign: 'right'}}>{s.year}</td>
                              <td style={{width: '10%'}}><span style={{backgroundColor: 'var(--primary-color-semitransparent)', padding: 5}} onClick={() => gotoStudentPage(s)}>{` >> `}</span></td>
                            </tr>,
                            renderEnrolmentNotes(s, i),
                          ]
                          );
                        })
                      }
                    </table>
                    )
                  : <div>No Students Selected</div>
                }
              </span>
            </div>

            <br></br>
              { updateMode ? 
                <div className="buttonRow">
                  <button
                    style={{marginRight: 20}}
                    type="submit"
                    disabled={saving}
                    className="btn btn-outline-primary"
                    onClick={updateEvent}
                  >
                    {saving ? (
                      <>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                          className="me-2"
                        />
                        Saving...
                      </>
                    ) : (
                      "Save"
                    )}
                  </button>
                  <button
                    style={{marginLeft: 'auto'}}
                    className="btn btn-danger"
                    disabled={saving}
                    onClick={deleteEvent}
                    >
                      {saving ? (
                        <>
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                            className="me-2"
                          />
                          Deleting...
                        </>
                      ) : (
                        "Delete"
                      )}
                  </button>
                </div>
                :
                <button
                  type="submit"
                  disabled={saving}
                  className="btn btn-outline-primary"
                  onClick={addEvent}
                >
                  {saving ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className="me-2"
                      />
                      Saving...
                    </>
                  ) : (
                    "Save"
                  )}
                </button>
              }
          </form>
       
        <p>{message}</p>
        <p className="errorText">{errorMessage}</p>
        </>
    )
  }

    return (
    <Container className="my-4">
      {/* MODERNIZED: Page is wrapped in a main Card for a modern look */}
      <Card className="shadow-sm">
        <Card.Body className="p-4">
          <h3 className="mb-4">{updateMode ? "Update Event" : "Add Event"}</h3>
          {loading ? <div className='loadingSpinner'><LoadingSpinner/></div> : renderBody()}
        </Card.Body>
      </Card>
    </Container>
  );
};

export default Event;